import React, { Component }  from 'react';
import InternalService from '../../services/internal-api';
import './saint.css';
import { LanguageContext } from '../../context/LanguageContext';
import { checkLanguageCookie } from '../../helpers/translation';

export default class Saint extends Component {

  data = new InternalService();
  static contextType = LanguageContext;

  state = {
    saint: null
  };

  async componentDidMount() {
    let searchParams = this.props.match.params;
    const isEnglish = await checkLanguageCookie();
    this.context.setEnglish(isEnglish);

    this.data.getSaint([searchParams["ss"]])
      .then((body) => {
        console.log(body.data)
        this.setState({
          saint: body.data
        });
      });
  }
  
  render() {
    const { saint } = this.state;
      
    if (!saint) {
      return (<br />)
    }

    const images = saint.path ? saint.path
    .split(' *-* ')
    .map((entry) => {
      const [id, caption] = entry.split(': ');
      return {
        url: `${this.data._apiBase}saint_images/${id}.jpg`,
        caption,
      };
    }) : [];

    const story = localStorage.token ? saint.story : saint.story_en;
    const iconography_header = localStorage.token ? 'Иконография' : 'Iconography';
    const iconography = localStorage.token ? saint.iconography : saint.iconography_en;

    return (
      <div>
        <div className="padding-left footer-widget-heading"><h3>{saint.name_en} {saint.epithet_en}</h3></div>
        <div className="padding-left story-description">{story}</div>
        <div className="padding-left indentation"><h6>{iconography_header}</h6></div>
        <div className="padding-left story-description">{iconography}</div>

        <div className="iconography-grid">
        {images.map((img, idx) => (
          <div key={idx} className="iconography-item">
            <div className="iconography-image-wrapper">
              <a href={img.url} target="_blank" data-zoompic>
                <img src={img.url} alt={img.caption} className="iconography-image" />
              </a>
            </div>
            <div className="iconography-caption">{img.caption}</div>
          </div>
        ))}
      </div>
      </div>
    )
  }
}